export default __webpack_public_path__ + "static/media/home-cafe-img-07.af8da829.png";